import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ConfigProviderProps } from 'antd';
import type { ProLayoutProps } from '@ant-design/pro-components';

interface LayoutState {
    /** 当前语言 */
    locale: 'zh-CN' | 'en-US';
    /** Ant Design 配置 */
    config: ConfigProviderProps;
    /** ProLayout 配置 */
    layout: ProLayoutProps;
    /** 设置语言 */
    setLocale: (locale: 'zh-CN' | 'en-US') => void;
    /** 设置配置 */
    setConfig: (config: Partial<ConfigProviderProps>) => void;
    /** 设置布局 */
    setLayout: (layout: Partial<ProLayoutProps>) => void;
}

export const useLayoutStore = create<LayoutState>()(
    persist(
        (set) => ({
            locale: 'zh-CN',
            config: {
                theme: {
                    token: {
                        colorPrimary: '#1890ff',
                    },
                },
            },
            layout: {
                layout: 'mix',
                navTheme: 'light',
                fixSiderbar: true,
                fixedHeader: true,
            },
            setLocale: (locale) => set({ locale }),
            setConfig: (config) =>
                set((state) => ({
                    config: { ...state.config, ...config },
                })),
            setLayout: (layout) =>
                set((state) => ({
                    layout: { ...state.layout, ...layout },
                })),
        }),
        {
            name: 'scheduling-layout',
            partialize: (state) => ({
                locale: state.locale,
            }),
        }
    )
);
